import './FileCard.css'
import cx from 'classnames'

export function FileCard({
  file,
  onRemove,
  isUploading
}: {
  file: { name: string; size: number; type: string }
  onRemove?: () => void
  isUploading?: boolean
}) {
  const extension = file.name.split('.').pop()?.toUpperCase() ?? ''
  return (
    <div className={cx('file-card', isUploading && 'file-card-uploading')}>
      <div className="file-card-content">
        <div className="file-card-extension">
          <span className="file-card-extension-text">{extension}</span>
        </div>
        <div>
          <p className="file-card-name">{file.name}</p>
          <p className="file-card-meta">
            {file.type} {(file.size / 1024 / 1024).toFixed(2)} MB
          </p>
        </div>
      </div>
      {onRemove && (
        <button onClick={onRemove} className="file-card-remove" type="button">
          <svg
            className="file-card-remove-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}
    </div>
  )
}
